import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
  selector: 'app-delete-video-dialog',
  templateUrl: './delete-video-dialog.component.html',
  styleUrls: ['./delete-video-dialog.component.scss']
})
export class DeleteVideoDialogComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<DeleteVideoDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) { }

  ngOnInit() {
  }

  onDelete() {

  }

}
